module.exports = __webpack_public_path__ + "708e7986f84cc789e60c40e013b15c2f.pdf";